import React, { useRef, useState } from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function CustomPrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block", background: '#0000', borderRadius: "50%" }}
            onClick={onClick}
        >
            <svg style={{ fill: "#FF5B2E" }} className='arrowbutton' version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 330 330" xmlSpace="preserve">
                <path id="XMLID_6_" d="M165,0C74.019,0,0,74.019,0,165s74.019,165,165,165s165-74.019,165-165S255.981,0,165,0z M205.606,234.394
	c5.858,5.857,5.858,15.355,0,21.213C202.678,258.535,198.839,260,195,260s-7.678-1.464-10.606-4.394l-80-79.998
	c-2.813-2.813-4.394-6.628-4.394-10.606c0-3.978,1.58-7.794,4.394-10.607l80-80.002c5.857-5.858,15.355-5.858,21.213,0
	c5.858,5.857,5.858,15.355,0,21.213l-69.393,69.396L205.606,234.394z"/>
            </svg>
        </div>
    );
}

function CustomNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, display: "block", background: "#0000", borderRadius: "50%" }}
            onClick={onClick}
        >
            <svg style={{ fill: "#FF5B2E" }} className='arrowbutton' version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 330 330" xmlSpace="preserve">
                <path id="XMLID_2_" d="M165,0C74.019,0,0,74.019,0,165s74.019,165,165,165s165-74.019,165-165S255.981,0,165,0z M225.606,175.605
	l-80,80.002C142.678,258.535,138.839,260,135,260s-7.678-1.464-10.606-4.394c-5.858-5.857-5.858-15.355,0-21.213l69.393-69.396
	l-69.393-69.392c-5.858-5.857-5.858-15.355,0-21.213c5.857-5.858,15.355-5.858,21.213,0l80,79.998
	c2.814,2.813,4.394,6.628,4.394,10.606C230,168.976,228.42,172.792,225.606,175.605z"/>
            </svg>
        </div>
    );
}

function Testimonials() {
    const [testimonial, setTestimonial] = useState(0); // Start with 0-based index
    const sliderref = useRef(null);
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        beforeChange: (oldIndex, newIndex) => setTestimonial(newIndex)
    };
    const handleClick = (index) => {
        sliderref.current.slickGoTo(index);
        setTestimonial(index);
    };
    const reviews = [
        {
            review: 'Highly recommended- Noorisys responded quickly and worked through every issue that arose during testing, delivering a great final product that is stable and performs exactly as specified. It is now live on Google Play, and receiving a very positive response from users, no small feat for a new app! I would definitely work with them again. Wonderful job!',
            person: 'DULITH HERATH',
            designation: 'CEO, ECOMMERCE PLATFORM, LK.',
            img: 'images/clients/dulith-herath.webp'
        },
        {
            review: `We are grateful to Noorisys Technologies for setting up our entire medical verification platform and maintaining the supply chain network for our services. I'm more than happy to work with Noorisys and the integrity with which they work and their commitment to delivering our assignment are very commendable.`,
            person: 'DR. MICHAEL FONSO ',
            designation: 'DIRECTOR, AEROMEDICAL CONSULTING, UK.',
            img: 'images/clients/michel.webp'
        },
        {
            review: 'We are thankful to Noorisys Technologies on supporting us in such a big project of developing our Government approved Online Travel Agency integrated with Maqam GDS. We wish Noorisys Technologies a success in their bright future as well.',
            person: 'KHALID IDRIS ',
            designation: 'CEO, MANAZIL AL MUKHTARA, KSA.',
            img: 'images/clients/khalid.webp'
        },
        {
            review: 'I have worked with the Noorisys team for two years now and I appreciate their dedicated support and timely services for my project. Thanks to the project management and development team for such a smooth project development and deployment.',
            person: 'IQBAL MAQSUD',
            designation: 'OWNER, BLACKBURN TRAVEL CLINIC, UK.',
            img: 'images/clients/image.webp'
        },
    ]
    return (
        <section className="r-bg-c sec-pad" id="review">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="heading-review text-center">
                            <h2 className="mb50">Clients <span className="ree-text rt40"></span>love <span className="ree-text rt40"></span>our innovative solutions and dedicated services</h2>
                            <div className="testimonial-card-b mt30">
                                <Slider {...settings} slidesToShow={1} ref={sliderref}>
                                    {reviews.map((review, index) => (
                                        <div className="review-slider" key={index}>
                                            <h4 className="mb20">{review.review}</h4>
                                            <div className="reviewers mt30">
                                                <div className="reviewers-nam">
                                                    <h4>{review.person}</h4>
                                                    <p>{review.designation}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                            <div className="clients-creative-pic mt30">
                                <div className="owl-dots" id="testimonials-avatar">
                                    {reviews.map((review, index) => (
                                        <button
                                            key={index}
                                            className={`dot-c1 tcc1 owl-dot mt30 mx-4 mx-sm-2 ${testimonial === index ? 'active' : ''}`}
                                            onClick={() => handleClick(index)}
                                        >
                                            {/* <img alt={reviews[index].person.toLowerCase().replace(" ", "-")} src={`images/clients/${reviews[index].person.toLowerCase().replace(" ", "-")}.webp`} /> */}
                                            <img alt={review.person.toLowerCase().replace(" ", "-")} src={review.img} />
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Testimonials
